import React from 'react';
import { Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 *
 */
class Layout_one_center  extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <div className="row-centered">
          <div className="col-centered">
            {this.componentDOM(0)}
          </div>
        </div>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_one_center;
